export default {
    // 泰语
    LOCALE_HTML: {
        'msg.language': 'th',
        'msg.title': 'หัวข้อ',
        'msg.type': 'แยกประเภทปัญหา',
        'msg.des': 'ยรรรยายปัญหา',
        'msg.phone': 'หมายเลขโทรศัพท์มือถือ',
        'msg.regionCode': 'รหัสพื้นที่',
        'msg.email': 'ตู้ไปรษณีย์',
        'msg.choose': 'เลือกประเภท',
        'msg.detail': 'ฝากข้อความรายละเอียด',
        'msg.back': 'กลับที่เดิม',
        'your.msg': 'กรุณาฝากข้อความด้วย',
        'msg.record': 'ข้อมูลที่ฝากข้อความ',
        'msg.success': 'ฝากข้อมูลสำเร็จ',
        'to.record': 'ไปยังข้อมูลที่ฝากข้อความ',
        completed: 'บรรลุผล',
        submit: 'เสนอให้',
        'success.desc': 'ข้อความของท่านเสนอให้แล้ว ขอบคุณค่ะ',
        'msg.form.input': 'กรุณาป้อนข้อมูล',
        'msg.reply': 'ตอบข้อความ',
        'comment.suc': 'ขอบตุณที่การประเมินค่าของท่าน',
        'comment.fail': 'เสนอให้พ่ายแพ้',
        'comment.placeholder': 'ยินดีต้อนรับทุกท่านยกข้อเสนอต่อบริการของเรา',
        'reply.suc': 'เสนอให้สำเร็จ',
        'reply.fail': 'กรุณาป้อนเนื้อหาการตอบข้อความของท่าน',
        'reply.placeholder': 'กรุณาป้อนเนื้อหาการตอบข้อความของท่าน',
        'msg.more': 'ตรวจสอบข้อความมากกว่า',
        'msg.collapse': 'ล้มลง',
        'msg.myservice': 'การประเมินค่าบริการของฉัน',
        'msg.evaluate': 'การประเมินค่าบริการ',
        'msg.evaluateTitle': 'การประเมินค่าบริการ',
        'msg.score': 'การให้คะแนน',
        'msg.remark': 'คำวิจารณ์',
        'msg.status.created': 'สร้างแล้ว',
        'msg.status.pending': 'รอจะยอมรับ',
        'msg.status.processing': 'ยอมรับอยู่',
        'msg.status.solved': 'ยอมรับแล้ว',
        'msg.service.reply': 'ตอบข้อความของผู้บริการลูกค้า',
        'msg.my.reply': 'คำตอบของคุณ',
        'msg.toast.des': 'การยรรรยายปัญหาว่างเปล่า',
        'msg.toast.type': 'การแยกประเภทปัญหาว่างเปล่า',
        'msg.toast.title': 'หัวข้อว่างเปล่า',
        'msg.toast.none': 'ว่างเปล่าไม่ได้',
        'msg.toast.noAnnex': 'กรุณาอัปโหลดเอกสารประกอบ',
        'msg.toast.noEmail': 'ตู้ไปรษณีย์ว่างเปล่าไม่ได้',
        'msg.toast.noTel': 'หมายเลขโทรศัพท์มือถือว่างเปล่าไม่ได้',
        'msg.toast.noRegionCode': 'รหัสพื้นที่ต้องไม่เว้นว่าง',
        'msg.toast.noZone': 'โปรดเลือกเขตเวลา',
        'msg.toast.noDateTime': 'กรุณาเลือกวันเวลา',
        'msg.toast.email': 'กรุณาป้อนตู้ไปรษณีย์ให้ถูกต้อง',
        'msg.toast.tel': 'กรุณาป้อนหมายเลขโทรศัพท์มือถือให้ถูกต้อง',
        'msg.toast.regionCode': 'กรุณาเลือกรหัสพื้นที่',
        'msg.toast.num': 'กรุณาป้อนตัวเลขให้ถูกต้อง',
        'msg.toast.annex': 'กรุณาอัปโหลดเอกสารประกอบ',
        'msg.toast.char': 'กรุณาป้อนตัวอักษรให้ถูกต้อง',
        'msg.list.none': 'ไม่มีข้อมูลเฉพาะกาล',
        'msg.form.choose': 'กรุณาเลือก',
        'msg.form.chooseZone': 'เลือกเขตเวลา',
        'msg.form.chooseTime': 'เลือกเวลา',
        'msg.form.chooseDate': 'เลือกวันที่',
        'msg.form.sure': 'ยืนยัน',
        'msg.form.search': 'ค้นหา...',
        'msg.form.uploadError': 'รูปแบบผิด',
        'msg.form.uploadXss':
            'การอัปโหลดล้มเหลว เนื้อหาไฟล์มีสคริปต์ที่ผิดกฎหมาย',
        'msg.update.time': 'อัพเดทเมื่อ',
        'msg.replace.images': 'รูปภาพ',

        MSG016: 'แก้ไข',
        MSG017: 'ยังไม่ได้แก้ไข',
        MSG019: 'ส่ง',
        MSG072: 'ป้ายกำกับการประเมินต้องไม่ว่างเปล่า! ',
        MSG073: 'ไม่สามารถเว้นว่างภาษาการประเมินได้! ',
        MSG074: 'ฉลาก:',
        MSG075: 'ได้รับการแก้ไขแล้วหรือไม่:',
        MSG076: 'โปรดเลือกว่าปัญหาได้รับการแก้ไขหรือไม่',
        MSG015: 'ตั๋วนี้แก้ไขปัญหาของคุณได้ไหม',

        'file.size.limit': 'ห้ามขนาดของไฟล์มากกว่า50MB',
        'detail.file.limit': 'ปริมาณมากที่สุดเป็น15ข้อห้ามขนาดมากกว่า50MB',
        'form.question.des.tip': 'กรุณาป้อนการยรรรยายปัญหา',
        'form.title.tip': 'กรุณาป้อนหัวข้อ',
        'form.class.tip': 'กรุณาเลือกการแยกประเภทปัญหา',
        'upload.file': 'อัปโหลดเอกสารประกอบ',
        'file.count.limit': 'สามารถอัปโหลด15เอกสารประกอบมากที่สุด',
        'select.search.placeholder': 'ค้นหาคีย์เวิร์ด',
        'msg.form.sizeError1': 'กรุณาอัปโหลดเอกสารประกอบในขนาดเล็กกว่า5M',
        'msg.form.sizeError2': 'กรุณาอัปโหลดเอกสารประกอบในขนาดเล็กกว่า50M',
        'msg.form.submit': 'กำลังเสนอให้อยู่',
        'msg.form.upload': 'กำลังอัปโหลดอยู่',
        'msg.email.tip1': 'ไม่สามารถเช็คความฝากข้อความของท่าน',
        'msg.email.tip2':
            'ถ้าท่านเคยฝากข้อความ ท่านสามารถครวจสอบดูโดยพิสูจร์ตู้ไปรษณีย์',
        'msg.email.tip3': 'เริ่มพิสูจร์ตู้ไปรษณีย์',
        'msg.email.noData': 'เลขบัณชีนี้ไม่มีข้อมูลเฉพาะกาล',
        'email.verify.tip': 'ป้อนตู้ไปรษณีย์ที่เวลาฝ่ากข้อความ',
        'email.input.placeholder': 'กรุณาป้อนตู้ไปรษณีย์',
        'email.submit': 'ส่งอีเมล',
        'email.rules.error': 'กรุณาป้อนตู้ไปรษณีย์ให้ถูกต้อง',
        'email.code.tip': 'อีเมลส่งแล้ว กรุณาป้อนเลขตรวจสอบที่ได้รับ',
        'email.code.placeholder': 'กรุณาป้อนเลขตรวจสอบ',
        'email.code.submit': 'ตรวจสอบดูทันที',
        'email.notFind.customer': 'ยังไม่ได้ตรวจสอบข้อมูลของลูกค้า',
        'email.code.wrong': 'เลขตรวจสอบพิด กรุณาป้อนอีกครั้ง',
        'email.code.expired':
            'เลขตรวจสอบเกินเวลาแล้ว กรุณาพิสูจร์ตู้ไปรษณีย์ทำใหม่',
        'email.code': 'เลขตรวจสอบ',
        'email.send.frequently': 'การคุมเครื่องมากม่าย กรุณาลองอีกสัครู่',
        'comment.fail.400133': 'ตั๋วนี้ได้รับการจัดอันดับ',
        'not.get.user.info': 'ไม่สามารถเข้าถึงข้อมูลของคุณได้',
        'user.verify.tip':
            'คุณต้องผ่านการตรวจสอบเพื่อดูเนื้อหาของรายการข้อความ',
        'verify.type.email': 'การตรวจสอบกล่องจดหมาย',
        'verify.text': 'การตรวจสอบ',
        'cancel.text': 'การยกเลิก',
        'get.verify.code': 'รับรหัสยืนยัน',
        'reGet.verify.code': 'Re-acquire ',
        'verify.by.email.tip':
            'รหัสยืนยันจะถูกส่งทางไปรษณีย์ไปยังหมายเลขบัญชีกล่องจดหมายที่คุณป้อน',
        'verify.type.phone': 'การตรวจสอบ SMS',
        'phone.placeholder': 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
        'verify.by.phone.tip':
            'รหัสยืนยันจะถูกส่งไปยัง SMS ไปยังหมายเลขโทรศัพท์มือถือที่คุณป้อน',
        'phone.error': 'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
        'phone.errorCode400150': 'ส่งรหัสยืนยันบ่อย',
        'phone.errorCode400233': 'แม่แบบ SMS ไม่สามารถว่างเปล่า',
        'phone.errorCode400234': 'ยอดคงเหลือ SMS การตลาดไม่เพียงพอ',
        'phone.errorCode400235': 'แจ้งยอดเงิน SMS ไม่เพียงพอ',
        'phone.errorCode400247': 'การกำหนดค่า SMS ปลั๊กอินการทำงานผิดพลาด',
        'phone.errorCode4400248': 'การรับเทมเพลต SMS ล้มเหลว',
        'phone.errorCode400249':
            'หมายเลขนี้ไม่ใช่หมายเลขโทรศัพท์มือถือของผู้ใช้ที่มีอยู่',
        'phone.errorCode400250': 'CAPTCHA หมดอายุ, โปรดกลับมาอีกครั้ง',
        'msg.you.reply': 'ตอบคุณแล้ว',
        'msg.no.reply':'ไม่มีการตอบกลับ',
    },
    LOCALE_REQUEST: {
        400016: 'การได้รับข้อมูลใบสั่งงานหมดอายุแล้ว โปรดรีเฟรช!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'ลบ',
                cancel: 'ยกเลิก',
                confirm: 'แน่นอน',
                inert: 'แทรก',
                width: 'ความกว้าง',
                height: 'สูง'
            },
            controls: {
                clear: 'เนื้อหาที่ชัดเจน',
                undo: 'ถอน',
                redo: 'ทำซ้ำ',
                fontSize: 'ขนาดตัวอักษร',
                lineHeight: 'ความสูงของเส้น',
                letterSpacing: 'ระยะห่างของคำ',
                textIndent: 'เยื้องย่อหน้า',
                increaseIndent: 'เพิ่มการเยื้อง',
                decreaseIndent: 'ลดการเยื้อง',
                border: 'กรอบ',
                color: 'สี',
                textColor: 'สีข้อความ',
                backgroundColor: 'สีพื้นหลัง',
                tempColors: 'สีชั่วคราว',
                bold: 'ตัวหนา',
                italic: 'ตัวเอน',
                underline: 'ขีดเส้นใต้',
                strikeThrough: 'ขีดทับ',
                fontFamily: 'แบบอักษร',
                textAlign: 'การจัดตำแหน่งข้อความ',
                alignLeft: 'ซ้าย',
                alignCenter: 'ในศูนย์',
                alignRight: 'ขวา',
                alignJustify: 'ปลายทั้งสอง',
                floatLeft: 'ลอยไปทางซ้าย',
                floatRight: 'ลอยไปทางขวา',
                superScript: 'ตัวยก',
                subScript: 'ตัวห้อย',
                removeStyles: 'สไตล์ที่ชัดเจน',
                headings: 'ชื่อ',
                header: 'ชื่อ',
                normal: 'ธรรมดา',
                orderedList: 'รายการสั่งซื้อ',
                unorderedList: 'รายการที่ไม่เรียงลำดับ',
                blockQuote: 'อ้าง',
                code: 'รหัส',
                link: 'ลิงค์',
                unlink: 'ลิงค์ที่ชัดเจน',
                hr: 'เส้นแนวนอน',
                media: 'สื่อ',
                mediaLibirary: 'ไลบรารีสื่อ',
                emoji: 'การแสดงออกเล็กน้อย',
                fullscreen: 'เต็มจอ',
                exitFullscreen: 'ออกจากโหมดเต็มหน้าจอ'
            },
            linkEditor: {
                textInputPlaceHolder: 'ป้อนข้อความลิงก์',
                linkInputPlaceHolder: 'ป้อนที่อยู่ลิงค์',
                inputWithEnterPlaceHolder: 'ป้อนที่อยู่ลิงก์แล้วกด Enter',
                openInNewWindow: 'เปิดหน้าต่างใหม่',
                removeLink: 'ลบลิงค์'
            },
            audioPlayer: {
                title: 'เล่นไฟล์เสียง'
            },
            videoPlayer: {
                title: 'เล่นไฟล์วิดีโอ',
                embedTitle: 'สื่อฝังตัว'
            },
            media: {
                image: 'ภาพ',
                video: 'วิดีโอ',
                audio: 'เสียง',
                embed: 'สื่อฝังตัว'
            }
        },
        finder: {
            remove: 'ลบ',
            cancel: 'ยกเลิก',
            confirm: 'ยืนยัน',
            insert: 'แทรกรายการที่เลือก',
            width: 'ความกว้าง',
            height: 'สูง',
            image: 'รูปภาพ',
            video: 'วิดีโอ',
            audio: 'เสียง',
            embed: 'สื่อฝังตัว',
            caption: 'ไลบรารีสื่อ',
            dragTip: 'คลิกหรือลากไฟล์มาที่นี่',
            dropTip: 'ปล่อยเพื่ออัปโหลด',
            selectAll: 'เลือกทั้งหมด',
            deselect: 'ยกเลิกการเลือก',
            removeSelected: 'ลบรายการที่เลือก',
            externalInputPlaceHolder: 'ชื่อทรัพยากร | ที่อยู่ทรัพยากร',
            externalInputTip: `ใช้ "|" เพื่อแยกชื่อทรัพยากรและที่อยู่ทรัพยากร`,
            addLocalFile: 'เพิ่มทรัพยากรในเครื่อง',
            addExternalSource: 'เพิ่มทรัพยากรบนเว็บ',
            unnamedItem: 'โครงการที่ไม่มีชื่อ',
            confirmInsert: 'แทรกรายการที่เลือก'
        }
    }
}
